import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-tab-links"},[_vm._l((_vm.links),function(item){return [_c(VBtn,{key:item.title,staticClass:"custom-pl-xs",class:{ 'app-tab-links__fill_required': _vm.isFillRequired(item) },attrs:{"to":item.url,"active":_vm.isActive(item.url),"disabled":_vm.isDisabled(item)}},[_vm._v(" "+_vm._s(item.title)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }